import React, {useState} from 'react'
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import UiSwitch from "../../../../_uiMocks/_uiComponents/UiSwitch"
import UiInput from '../../../../_uiMocks/_uiComponents/UiInput';
import { UiButton, UiBackButton } from '../../../../_uiComponents/common/form/UiButton';
import UiInnerSearchWr from '../../../../_uiComponents/common/UiInnerSearchWr';
import Checkbox from "@mui/material/Checkbox";
import { Collapse } from '@mui/material';
import { UiInputGroupWr } from '../../../../_uiComponents/common/form/UiInputComponents';


export default function CreateRolesForm() {

    const [contains, setContains] = React.useState('');
    let navigate = useNavigate();

    const handleContainChange = (event) => {
        setContains(event.target.value);
    };

    const handleClick = () => {
        //  clear input value
        setContains('');
    };


  const [expanded, setExpanded] = useState(false);

const [childCheckboxes, setChildCheckboxes] = useState({
    create: false,
    edit: false,
    delete: false
  });

  const handleExpandToggle = () => {
    const newState = !expanded;
    setExpanded(newState);
    setChildCheckboxes({
      create: newState,
      edit: newState,
      delete: newState
    });
  };

  const handleChildCheckboxChange = (name) => (event) => {
    setChildCheckboxes({ ...childCheckboxes, [name]: event.target.checked });
  };


    return (
        <>
            <UiInnerSearchWr>
            <Grid container spacing={2}>
                <div className='sba-um-roles-wr'>
                    <Grid item xs={12} lg={6} >
                        <UiInput type="text" label="Role Name" />                                                             
                        </Grid>

                        <UiInputGroupWr title="Select Role Permissions" className="sba-um-checkbox-content">
                        <div>
                            <div onClick={handleExpandToggle}>
                                <FormControlLabel
                                label="Incentive"
                                control={
                                    <Checkbox
                                    checked={expanded}            
                                    />
                                }
                                />
                            </div>
                            <div className='sba-role-checkbox-content'>
                            <Collapse in={expanded} unmountOnExit>
                                <FormControlLabel
                                label="Create Incentive"
                                control={<Checkbox 
                                    checked={childCheckboxes.create}
                                    onChange={handleChildCheckboxChange('create')}/>}
                                />
                                <FormControlLabel
                                label="Edit Incentive"
                                control={<Checkbox checked={childCheckboxes.edit}
                                    onChange={handleChildCheckboxChange('edit')}
                                    />}
                                />
                                <FormControlLabel
                                label="Delete Incentive"
                                control={<Checkbox 
                                    checked={childCheckboxes.delete}
                                    onChange={handleChildCheckboxChange('delete')}
                                  />}
                                />
                            </Collapse>
                            </div>
                            <div onClick={handleExpandToggle}>
                                <FormControlLabel
                                label="Incentive"
                                control={
                                    <Checkbox
                                    checked={expanded}            
                                    />
                                }
                                />
                            </div>
                            <div className='sba-role-checkbox-content'>
                            <Collapse in={expanded} unmountOnExit>
                                <FormControlLabel
                                label="Create Incentive"
                                control={<Checkbox />}
                                />
                                <FormControlLabel
                                label="Edit Incentive"
                                control={<Checkbox />}
                                />
                                <FormControlLabel
                                label="Delete Incentive"
                                control={<Checkbox />}
                                />
                            </Collapse>
                            </div>
                        </div>
                        </UiInputGroupWr>
                <FormControlLabel control={
                        <UiSwitch />}
                            label="Active"
                            labelPlacement="top"
                            sx={{ mt: 2 }}
                            className='sba-switch-label-um-roles' />
                </div>
                    <Grid item xs={12}>
                        <Stack spacing={2} direction="row" justifyContent="space-between" alignItems={"center"} sx={{ width: '100%' }}>
                            <UiBackButton size="small" onClick={() => navigate(-1)} />
                            <div className='sbt-right-action-btn-wr'>
                                <UiButton onClick={handleClick} name="Clear" variant="outlined" size="small" />
                                <UiButton name="Update" variant="contained" size="small" />
                            </div>
                        </Stack>
                    </Grid>
                    </Grid>
            </UiInnerSearchWr>
        </>
    )
}
